/* eslint-disable no-console */
import _ from 'underscore';
import { addMultipleProductDealerShareModal } from '../dealer-contact/multiple-product-dealer-share-modal';
import { getAssetSharingHtml } from '../../utils/social-media-sharing';
import { getIdFromAssetUrl } from '../widen-utils';
import { getItemsFromAccount, removeItemFromAccount } from '../consumer-account/storage-actions';
import { getPartialDimensionValue } from '../../utils/measurements';
import { updateProduct } from '../consumer-account/account-api';
import SiteModal from '../site-modal';
import SiteToaster from '../site-toaster';

_.templateSettings = {
  interpolate: /\{\{(.+?)\}\}/g,
};

const template =
  `<div class="col d-flex">
    <div class="product-card product-card-saved d-flex align-self-stretch mb-5" data-asset-id="{{ assetId }}">
      <div class="card-wrapper">
        <button class="card-image view-product-details-btn" data-asset-id="{{ assetId }}" aria-label="View Product Details">
          <div class="object-fit site-image-wrapper">
            <img alt="" class="lazy site-image" src="{{ widenUrl }}" />
          </div>
        </button>
        <div class="card-content py-4 px-2">
          <div class="heading-xs mb-1">{{ tileName }} - {{ color }}</div>
          <button class="more-link view-product-details-btn" data-asset-id="{{ assetId }}">+ View Details</button>
        </div>
      </div>
    </div>
  </div>`;

const noItemsTemplate =
  `<div class="row">
    <div class="col">
      <div class="rounded-box bg-gray p-5">
        {{ content }}
      </div>
    </div>
  </div>`;

const templateVals = _.template(template);
const noItemsTemplateVals = _.template(noItemsTemplate);
const modalDiv = document.querySelector('.product-detail-modal');
let items = [];

const props = {
  removePageItemById: null,
  getItemById: null,
  updateSwatchbook: null,
  enqueuePdfUtilsData: null,
};

const hasItems = () => (
  items.length !== 0
);

const update = () => {
  const { NoProductsContent } = window;
  const div = document.createElement('div');
  const selector = document.querySelector('.products-content');
  if (items.length === 0) {
    const compiled = noItemsTemplateVals({
      content: NoProductsContent,
    });
    div.innerHTML = compiled;
    selector.innerHTML = '';
    selector.appendChild(div.firstChild);
  }
  props.updateSwatchbook();
};

// Init product detail modal
const modal = new SiteModal({
  id: 'product-detail-modal',
  callbacks: {
    onOpen: () => {
      updateModalHeight(); /* eslint-disable-line no-use-before-define */
    },
    onClose: () => {
      // Close toaster if open
      const toaster = document.getElementById('status-toaster');
      if (toaster) {
        toaster.remove();
      }
    },
  },
});

const updateModalHeight = () => {
  const modalContent = modalDiv.querySelector('.modal-content');
  if (modalContent) {
    const contentHeight = modalContent.offsetHeight + 30;
    modalDiv.querySelector('.modal-panel').style.height = `${contentHeight}px`;
  }
};

const updateProductInfo = (event) => {
  event.preventDefault();
  const width1 = modalDiv.querySelector('#Width1').value;
  const width2 = modalDiv.querySelector('#Width2').value;
  const height1 = modalDiv.querySelector('#Height1').value;
  const height2 = modalDiv.querySelector('#Height2').value;
  const assetId = modalDiv.querySelector('#DigitalAssetId').value;
  const notes = modalDiv.querySelector('#Notes').value;
  const windowHeight = height1 === 'any' ? 0 : parseFloat(`${height1}${height2}`);
  const windowWidth = width1 === 'any' ? 0 : parseFloat(`${width1}${width2}`);
  updateProduct(
    {
      'digital-product-id': assetId,
      notes,
      'window-height': windowHeight,
      'window-width': windowWidth,
    },
    (data) => {
      // console.log(data);
      if (data.success) {
        // Update local data w/ new values
        const item = props.getItemById(items, assetId);
        item.notes = notes;
        item.windowHeight = windowHeight;
        item.windowWidth = windowWidth;
        const toaster = new SiteToaster({
          id: 'status-toaster',
          message: 'Your product information has been updated.',
        });
        toaster.open();
      }
    },
  );
};

const removeProductCardByAssetId = (id) => {
  const card = document.querySelector(`.product-card[data-asset-id="${id}"]`);
  if (card) {
    card.parentNode.remove();
  }
};

const removeProductFromFavorites = (event) => {
  event.preventDefault();
  const btn = event.target;
  if (btn) {
    const assetId = btn.getAttribute('data-asset-id');
    if (assetId) {
      removeItemFromAccount('product', assetId, () => {
        // Remove product card
        removeProductCardByAssetId(assetId);
        // Remove modal
        modal.close();
        props.removePageItemById(items, assetId);
        update();
      });
    }
  }
};

const populateSavedContentInModal = (data) => {
  const {
    assetId,
    color,
    notes,
    productUrl,
    tileName,
    widenUrl,
  } = data;
  // Dimensions
  const width1 = modalDiv.querySelector('#Width1');
  const width2 = modalDiv.querySelector('#Width2');
  const height1 = modalDiv.querySelector('#Height1');
  const height2 = modalDiv.querySelector('#Height2');
  width1.value = getPartialDimensionValue(width1.id, data);
  width2.value = getPartialDimensionValue(width2.id, data);
  height1.value = getPartialDimensionValue(height1.id, data);
  height2.value = getPartialDimensionValue(height2.id, data);
  // Title/color
  const productTileLink = modalDiv.querySelector('.saved-product-tile-link');
  const productTileName = modalDiv.querySelector('.saved-product-tile-name');
  const productColorName = modalDiv.querySelector('.saved-product-color-name');
  productTileName.innerHTML = tileName;
  // Set url
  productTileLink.setAttribute('href', productUrl);
  productColorName.innerHTML = color;
  // Notes
  const notesIpt = modalDiv.querySelector('#Notes');
  notesIpt.value = notes;
  // Asset Id
  const digitalAssetIdIpt = modalDiv.querySelector('#DigitalAssetId');
  digitalAssetIdIpt.value = assetId;
  // Image
  const productImg = modalDiv.querySelector('.saved-product-img');
  const img = productImg.querySelector('img');
  if (img) {
    img.src = widenUrl;
    img.setAttribute('alt', '');
  } else {
    const addImg = document.createElement('img');
    addImg.classList.add('site-image');
    addImg.src = widenUrl;
    addImg.setAttribute('alt', '');
    productImg.appendChild(addImg);
  }
  // Remove product button
  const removeProductBtn = modalDiv.querySelector('.remove-product-btn');
  removeProductBtn.setAttribute('data-asset-id', assetId);
};

const onViewProductDetailById = (id) => {
  const item = props.getItemById(items, id);
  // Set dimension values
  populateSavedContentInModal(item);
  // Add social media shares
  const socialMediaSharingWrapper = modalDiv.querySelector('.social-media-sharing');
  socialMediaSharingWrapper.innerHTML = getAssetSharingHtml(item);
  // Open modal
  modal.open();
};

const addEventHandlers = () => {
  const productDetailBtns = document.querySelectorAll('.view-product-details-btn');
  [].map.call(productDetailBtns, btn => btn.addEventListener('click', () => {
    const assetId = btn.getAttribute('data-asset-id');
    onViewProductDetailById(assetId);
  }));
  // Remove product
  const removeProductBtn = modalDiv.querySelector('.remove-product-btn');
  removeProductBtn.addEventListener('click', removeProductFromFavorites);
  // Update product
  const updateProductBtn = modalDiv.querySelector('.submit-btn');
  updateProductBtn.addEventListener('click', updateProductInfo);
  window.addEventListener('resize', updateModalHeight);
};

const onLoaded = (data) => {
  // Map data
  items = data.products.map(item => ({
    assetId: item['product-id'],
    color: item.color,
    name: item.name,
    description: item['tile-name'],
    notes: item.notes,
    productKey: item['product-key'],
    productUrl: item['product-url'],
    shareLink: encodeURIComponent(item['product-url']),
    src: item['widen-url'],
    tileName: item['tile-name'],
    widenUrl: item['widen-url'],
    windowHeight: item['window-height'],
    windowWidth: item['window-width'],
    type: 'product', // for pdfutils,
    imageUrl: item['widen-url'], // for pdfutils
    id: getIdFromAssetUrl(item['widen-url']), // for pdfutils
  }));
  // Display saved content
  if (items.length > 0) {
    const selector = document.querySelector('.products-content');
    const div = document.createElement('div');
    div.classList = 'row row-cols-3 row-cols-sm-4 row-cols-lg-5';
    selector.innerHTML = '';
    items.forEach((item) => {
      const itemDiv = document.createElement('div');
      const compiled = templateVals(item);
      itemDiv.innerHTML = compiled;
      div.appendChild(itemDiv.firstChild);
    });
    selector.appendChild(div);
  }
  props.enqueuePdfUtilsData(items);
  // Init dealer share modal
  addEventHandlers();
  addMultipleProductDealerShareModal();
  update();
};

const init = (options) => {
  const {
    enqueuePdfUtilsData,
    getItemById,
    removePageItemById,
    updateSwatchbook,
  } = options;
  props.enqueuePdfUtilsData = enqueuePdfUtilsData;
  props.getItemById = getItemById;
  props.removePageItemById = removePageItemById;
  props.updateSwatchbook = updateSwatchbook;
  getItemsFromAccount('product', onLoaded);
};

export {
  hasItems,
  init,
  onLoaded,
};
/* eslint-enable no-console */
